import { Controller } from "@hotwired/stimulus"

// Keeps the whole email-code login sequence inside one modal (VI-1785) instead of
// navigating to /login and /login/verify. Layers on top of passcode-form, which still
// owns the double-submit guard and code-field formatting -- this controller only takes
// over where the request actually goes (fetch, not a page navigation) and what happens
// with the response.
export default class extends Controller {
  static targets = ["emailStep", "codeStep"]
  static values = { connectionError: String }

  submitEmail(event) {
    event.preventDefault()
    this.post(event.target, (data) => {
      if (data.ok) {
        this.showCodeStep()
      } else {
        this.showError(event.target, data.error)
      }
    })
  }

  submitCode(event) {
    event.preventDefault()
    this.post(event.target, (data) => {
      if (data.ok) {
        window.location.href = data.redirect
      } else {
        this.showError(event.target, data.error)
      }
    })
  }

  backToEmail(event) {
    event.preventDefault()
    this.codeStepTarget.classList.add("d-none")
    this.emailStepTarget.classList.remove("d-none")
    this.clearError(this.emailStepTarget)
  }

  showCodeStep() {
    this.clearError(this.emailStepTarget)
    this.emailStepTarget.classList.add("d-none")
    this.codeStepTarget.classList.remove("d-none")
  }

  showError(form, message) {
    this.clearError(form.closest("[data-login-modal-target]"))
    const el = document.createElement("p")
    el.className = "login-modal-error text-danger mt-2"
    el.textContent = message
    form.prepend(el)
  }

  clearError(step) {
    step?.querySelectorAll(".login-modal-error").forEach((el) => el.remove())
  }

  // Rack::Attack answers a 429 as plain text, not JSON, and the request can fail outright
  // (offline, timeout) before any response exists -- both must still re-enable the form.
  async post(form, callback) {
    let data
    try {
      const response = await fetch(form.action, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        },
        body: new FormData(form)
      })
      data = await response.json()
    } catch {
      this.resetSubmitState(form)
      this.showError(form, this.connectionErrorValue)
      return
    }

    this.resetSubmitState(form)
    callback(data)
  }

  // passcode-form owns the double-submit guard (button disabled + is-submitting) for both the
  // full-page and modal login, but it only knows to lift it on a real page load (`pageshow`) --
  // this modal never navigates, so it has to lift it itself once the fetch settles.
  resetSubmitState(form) {
    this.application.getControllerForElementAndIdentifier(form, "passcode-form")?.reset()
  }
}
